import { render, staticRenderFns } from "./SalesChart.vue?vue&type=template&id=184cebb6&scoped=true&"
import script from "./SalesChart.vue?vue&type=script&lang=js&"
export * from "./SalesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184cebb6",
  null
  
)

export default component.exports